import { useNavigate } from "react-router-dom";
import "./membership.scss";
import { LiaTimesSolid } from "react-icons/lia";

const Membership = () => {
  const navigate = useNavigate();
  const navigateToCreate = () => {
    navigate("/create-account");
  };
  return (
    <div className="main-container platinum-landing">
      <div className="platinum-title">
        <h1>Platinum Membership</h1>
      </div>
      <div className="membership">
        <div className="subscription-video">
          <iframe
            src="https://thewoodsmithstore.com/wp-content/uploads/2023/01/CMT_BowlTrayBitSet_web.mp4"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div className="member-container">
          <div className="member-top">
            <h2>Become A Platinum Member!</h2>
            <h3>Only $9.95/year</h3>
          </div>
          <p>
            Sign up for membership and start watching videos, commenting, and
            saving your favorite content
          </p>
          <ul className="member-list-items">
            <li>
              <span>{<LiaTimesSolid />}</span>
              <strong>Full Access</strong>
              <p>to the Video Tip Library</p>
            </li>
            <li>
              <span>{<LiaTimesSolid />}</span>
              <strong>Full Access</strong>
              <p>to Premium Seminars, Classes, and Techniques Videos</p>
            </li>
            <li>
              <span>{<LiaTimesSolid />}</span>
              <strong>Full Access</strong>
              <p>to Downloadable PDF Project Plans!</p>
            </li>
            <li>
              <span>{<LiaTimesSolid />}</span>
              <strong>Get New Videos</strong>
              <p>every week!</p>
            </li>
          </ul>
          <div className="member-image-container">
            <h2>PLUS!</h2>
            <h3>
              Get a Free 16-Page Ebook, The Ultimate Mortising Jig + Loose Tenon
              Joinery
            </h3>
            <div className="member-image">
              <img
                src="https://woodsmithstorecontent.s3.us-east-2.amazonaws.com/logo/WS-Tips-Mag_2.jpg"
                alt="mortising jig"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Membership;
